export default "__VITE_ASSET__ukW2y6zw__"